import React, { Component } from 'react'
import { withFirebase } from 'react-redux-firebase'

import Layout from '../Layout'

import './claim-your-profile.scss'

class ClaimYourProfile extends Component {

    constructor (props, firebase) {
        super(props)

        this.titleRef = React.createRef()
        this.paragraphRef = React.createRef()

        this.urlRef = React.createRef()
        this.emailRef = React.createRef()

        this.btnRef = React.createRef()
        this.errorRef = React.createRef()

        this.refsArr = [
            this.titleRef,
            this.paragraphRef,
            this.urlRef,
            this.emailRef,
            this.btnRef
        ]

    }

    componentDidMount () {
        let refCounter = 0
        this.fadeInterval = setInterval(() => {
            if (refCounter === this.refsArr.length) {
                refCounter = 0
                clearInterval(this.fadeInterval)
            }
            this.refsArr[refCounter].current.className += ' active'
            refCounter += 1
        }, 150)
    }

    componentWillUnmount () {
        if (this.successTimeout) {
            clearTimeout(this.successTimeout)
        }
        clearInterval(this.fadeInterval)
    }

    onSubmit = e => {
        e.preventDefault()
          
        const { firebase } = this.props
        const url = this.urlRef.current.value
        const email = this.emailRef.current.value
        
        const data = {
            url,
            email
        }
        firebase.push('draftCompanies', data, err => {
            if (err) {
                this.errorRef.current.className += ' visible'
                return
            }
            
            this.successTimeout = setTimeout(() => {

                this.refsArr.reverse().forEach((item, i) => {
                    const timeout = setTimeout(() => {
                        item.current.className = 'fade-in'
                        clearTimeout(timeout)
                        if (i === this.refsArr.length - 1) {
                            const showTimeout = setTimeout(() => {
                                this.titleRef.current.innerHTML = `
                                    Application successful!
                                    <br />
                                `
                                this.paragraphRef.current.innerHTML = `
                                    <img src="https://media1.tenor.com/images/39bb19d865610b4612ff15ee543edaee/tenor.gif?itemid=3367901" alt="Success thumbs-up GIF." />
                                    <br />
                                    <br />
                                    Thanks for applying.
                                    <br />
                                    A representative of ours will get back to you as soon as possible.
                                `

                                this.titleRef.current.className += ' active'
                                this.paragraphRef.current.className += ' active'
                                
                                clearTimeout(showTimeout)

                            }, 500)
                        }
                    }, i * 50)
                })
                clearTimeout(this.successTimeout)
            })

        })
        
    }

    render () {
        return (
            <div>
                <Layout>
                    <div className="claim-your-profile">
                        <main className="container-tiny">
                            <h1 className="fade-in" ref={this.titleRef}>Hi there,</h1>
                            <p className="fade-in" ref={this.paragraphRef}>
                                Our platform is currently closed for beta users only. <br />
                                Please provide us with your contact information to review and you'll be informed when your company has been added to the directory.
                            </p>
                            <form onSubmit={this.onSubmit}>
                                <input 
                                    required
                                    className="fade-in" 
                                    type="text" 
                                    ref={this.urlRef}
                                    placeholder="Company Website" />
                                <input 
                                    required
                                    className="fade-in" 
                                    type="email"
                                    ref={this.emailRef}
                                    placeholder="Your Email" />
                                <input 
                                    className='fade-in'
                                    ref={this.btnRef}
                                    type="submit" 
                                    value="Send Mail" />
                            </form>
                            <div 
                                className="error"
                                ref={this.errorRef}>
                                There was error with submitting your data. Please try again.
                            </div>
                        </main>
                    </div>  
                </Layout>
            </div>
        )
    }
}

export default withFirebase(ClaimYourProfile)


// WEBPACK FOOTER //
// ./src/components/claim-your-profile/index.jsx